import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getSalesType = async () => {
  const { data } = await axios.get(`${api_base_url}/SalesType/SalesType`);
  return data;
};
export const addSalesType = async (newSalesType) => {
  const { data } = await axios.post(`${api_base_url}/SalesType`, {
    ...newSalesType[0],
  });
  return data;
};
export const updateSalesType = async (updatedSalesType) => {
  const { data } = await axios.put(
    `${api_base_url}/SalesType/${updatedSalesType[0].salesTypeId}`,
    updatedSalesType[0]
  );
  return data;
};

export const deleteSalesType = async (ids) => {
  await axios.delete(`${api_base_url}/SalesType/`, {
    data: ids,
  });
};
